<ng-container *ngIf="state$ | async as state">

<mat-card class="m-t-25 p-25">

  <div class="tuni-box-title-1 text-azul-sunedu font-bold m-b-15">Bandeja de datos</div>

  <div class="m-b-5">
    Archivos seleccionados para la descarga:
  </div>
  <div
    fxLayout="row wrap"
    fxLayoutGap="5px">
    <mat-card
      class="m-t-5 m-b-5"
      fxFlex="0 1 calc(50% - 5px)" *ngFor="let item of state.archivoDescarga">
      <div fxLayout="row">
        <div fxFlex="45%">
          <button class="tuni-icon-button" *ngFor="let archivo of item.archivos">
            <span
              [matTooltip]="archivo.formato"
              class="tuni-icono-lg tuni-icono-{{archivo.formato}} cursor-pointer"></span>
          </button>
        </div>
        <div
          fxFlex="55%"
          fxLayoutAlign="flex-start center">
          <div>
            {{item.tipo}}
            <br>
            {{item.periodo}}
          </div>
          <span class="flex-spacer"></span>
          <button mat-icon-button>
            <mat-icon class="text-gray-sunedu2"  (click)="eliminarFormato(item)">delete</mat-icon>
          </button>
        </div>
      </div>
    </mat-card>

  </div>

  <div class="text-center m-t-25">
    <button *ngIf="state.archivoDescarga.length > 0"
      mat-button
      [disabled]=state.loading
      class="rounded-full bg-azul-sunedu" (click)="descarga()">
      {{state.loading?'Descargando':'Descargar'}}
    </button>
  </div>

</mat-card>
</ng-container>
